// Stub config for CI builds - replaced by deploy.sh with real values
const CONFIG = {
  region: "",
  userPoolId: "",
  userPoolClientId: "",
  apiUrl: "",
  cognitoDomain: "",
  midwayEnabled: false,
};

export default CONFIG;
